import React from 'react';

const Donate = () => {
  return (
    <main className="min-h-screen bg-white text-gray-800 p-6 md:p-12">
      {/* Hero */}
      <section className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Support EmpowerHer</h1>
        <p className="text-lg max-w-2xl mx-auto">
          Your donation empowers girls and women to gain digital skills, unlock opportunities, and change their lives.
        </p>
      </section>

      {/* Donation Options */}
      <section className="max-w-2xl mx-auto mb-12">
        <h2 className="text-2xl font-semibold mb-4 text-center">Choose Your Donation Amount</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          {["$10", "$25", "$50", "$100"].map((amount) => (
            <button
              key={amount}
              className="bg-indigo-100 text-indigo-800 font-bold py-3 rounded-lg hover:bg-indigo-200 transition"
            >
              {amount}
            </button>
          ))}
        </div>
        <input
          type="number"
          placeholder="Other amount"
          className="w-full border rounded-lg p-3 mb-4"
        />
        <button className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700">
          Donate Now
        </button>
        <p className="text-sm text-gray-600 mt-2 text-center">Secured by Stripe or PayPal</p>
      </section>

      {/* Impact */}
      <section className="mb-16">
        <h2 className="text-2xl font-semibold text-center mb-6">Your Donation Makes a Difference</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="p-6 border rounded-lg shadow-sm">
            <p className="text-xl font-bold text-indigo-600">$10</p>
            <p>Buys data access for one girl for a week</p>
          </div>
          <div className="p-6 border rounded-lg shadow-sm">
            <p className="text-xl font-bold text-indigo-600">$25</p>
            <p>Provides access to one complete digital course</p>
          </div>
          <div className="p-6 border rounded-lg shadow-sm">
            <p className="text-xl font-bold text-indigo-600">$50</p>
            <p>Supports a mentorship or community tech session</p>
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section className="bg-indigo-50 p-8 rounded-lg mb-16 max-w-3xl mx-auto">
        <blockquote className="text-center text-xl italic">
          “EmpowerHer helped me build my first website. Now I’m teaching others in my village.”
        </blockquote>
        <p className="text-center mt-4 font-semibold">— Achieng, 17, Kenya</p>
      </section>

      {/* FAQs */}
      <section className="max-w-3xl mx-auto">
        <h2 className="text-2xl font-semibold text-center mb-6">Frequently Asked Questions</h2>
        <div className="space-y-4">
          <div>
            <h3 className="font-bold">Is my donation tax-deductible?</h3>
            <p>Currently, we are not tax-exempt. We’re working toward this status and will update donors.</p>
          </div>
          <div>
            <h3 className="font-bold">Can I donate in another currency?</h3>
            <p>Yes! Our payment provider supports most currencies globally.</p>
          </div>
          <div>
            <h3 className="font-bold">Can I donate monthly?</h3>
            <p>Recurring donations are coming soon! For now, you can manually donate again anytime.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Donate;
